<template>
  <div>
    <div v-if="vehicles">
      <h3>List of TC Active Vehicles</h3>
      <table style="width:600px">
        <tr>
          <th>Vehicle #</th>
          <th>Make</th>
          <th>Colour</th>
          <th>Plate</th>
          <th>Capacity</th>
          
          <th>Drivers</th>
          
        </tr>

        <tr v-for="vehicle in vehicles" :key="vehicle.vehicle_id">
          <td>{{vehicle.vehicle_id}}</td>
          <td>{{vehicle.tags.make}}</td>
          <td>{{vehicle.tags.color_name}}</td>
          <td>{{vehicle.tags.plate}}</td>
          <td>{{vehicle.tags.capacity}}</td>
          <td v-if="vehicle.access.drivers">
            <span v-for="driver in driversForIDs(vehicle.access.drivers)" :key="driver.id">
              <span v-if="driver">
                <span v-if="driver.roles===0">❌</span>
                <span v-if="driver.roles===1">✅</span>
                {{driver.data.operator_nbr}}:
                {{driver.first_name}} {{driver.last_name}}, &nbsp;&nbsp;
              </span>
              <span v-else>error</span>
            </span>
          </td>
          <td v-else>...</td>
          
        </tr>
      </table>
      <p>
        Convienience links: 
        <a href="https://admin.taxicaller.net/admin/vehicles/vehicles.php" target="_blank">TC Admin - Vehicles</a>↗︎
      </p>
    </div>
    <div v-else>
      ... Loading
    </div>
  </div>
</template>

<script>
export default {
  name:"TCVehicles",
  inject: ['operatorPage'],
  data(){
    return {

    }
  },
  computed:{
    vehicles(){
      return this.operatorPage.$refs.operatorStore.vehicles
    }
  },
  methods:{
    driver(id){
      return this.operatorPage.$refs.operatorStore.driverForID(id)
    },
    driversForIDs(driverIDsArray){
      return this.operatorPage.$refs.operatorStore.driversForIDs(driverIDsArray)
    }
  },
}
</script>